<template>
  <div>
    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">

      <FormItem label="软件分类" prop="type">
        <Input v-model="formValidate.type" placeholder="请输入软件分类"></Input>
      </FormItem>

      <FormItem label="版本名称" prop="versionName">
        <Input v-model="formValidate.versionName" placeholder="请输入版本名称"></Input>
      </FormItem>

      <FormItem label="版本号" prop="versionCode">
        <Input  v-model="formValidate.versionCode" placeholder="请输入版本号"></Input>
      </FormItem>

      <FormItem label="版本描述">
        <Input type="textarea" v-model="formValidate.comment" placeholder="请输入版本描述"></Input>
      </FormItem>

      <FormItem label="解压路径">
        <Input v-model="formValidate.unzipPath" placeholder="请输入解压路径（可选，默认：/home/sinano/images/triton_server/models_10.3）"></Input>
      </FormItem>

      <FormItem label="Docker容器名">
        <Input v-model="formValidate.dockerName" placeholder="请输入Docker容器名（可选，默认：tritonserver-gpu）"></Input>
      </FormItem>

      <FormItem label="请上传文件" prop="downloadUrl">
        <input type="file" @change="handleChange" ref="pathFileInput" />
        <label class="search-label">{{ show_path }}</label>
        <Button type="info" v-if='loadding' :loading="loadding">
          <span>上传中</span>
        </Button>
      </FormItem>

      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button type="primary" @click="handleSubmit('formValidate')" style="margin-left: 8px">提交</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

import moment from 'moment';
const { v4: uuidv4 } = require('uuid');
import {uploadFile, calculateFileMd5} from "@/api/uploadOss";

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => { }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      classifyIds: [],
      loadding: false,
      video_show: false,
      show_path: '',
      bgm: '',
      formValidate: {
        id: '',
        type: '',
        versionName: '',
        downloadUrl: '',
        versionCode: '',
        comment: '',
        md5: '',
        unzipPath: '/home/sinano/images/triton_server/models_10.3',
        dockerName: 'tritonserver-gpu',
        versionType: 'aiqc'
      },
      ruleValidate: {
       type: [
          {
            required: true,
            message: '软件分类不能为空',
            trigger: 'blur'
          }
        ], versionName: [
          {
            required: true,
            message: '版本名称不能为空',
            trigger: 'blur'
          }
        ], versionCode: [
          {
            required: true,
            message: '版本号不能为空',
            trigger: 'blur'
          }
        ], downloadUrl: [
          {
            required: true,
            message: '必须上传文件',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag(resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    getVideoResolution() {
      const video = this.$refs.video;
      if (video && video.videoWidth && video.videoHeight) {
        this.formValidate.resolving_power = video.videoWidth + "x" + video.videoHeight
      }
    },
    async handleChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.video_show = true
      this.bgm = URL.createObjectURL(file);
      try {
        this.loadding = true
        let currentDate = moment().format('YYYY-MM-DD');
        const uuid = uuidv4()
        
        // 上传文件
        var name = file.name.substring(file.name.lastIndexOf('.'))
        this.formValidate.name = file.name.substring(0, file.name.lastIndexOf('.'))

        // 使用版本号作为目录名，上传到 pic/version/版本号/ 目录
        var result = await uploadFile('pic/version/' + this.formValidate.versionName + '/' + uuid + name, file);
        if (result != '') {
          this.formValidate.downloadUrl = result
          this.$Message.info('上传成功');
          
          // 获取文件的md5
          this.formValidate.md5 = await calculateFileMd5(file);
          console.info(this.formValidate.md5)
        } else {
          this.$Message.error('上传失败');
          this.$refs.pathFileInput.value = ''
        }

      } catch (error) {
        console.info(error)
        this.$Message.error('上传失败');
        this.$refs.pathFileInput.value = ''
      }

      this.loadding = false
    }, 
    setClassifyData(classify_list) {
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    setEditData(editData) {
      this.formValidate.id = editData.id
      this.formValidate.type = editData.type
      this.formValidate.versionCode = editData.versionCode.toString()
      this.formValidate.versionName = editData.versionName
      this.formValidate.comment = editData.comment || editData.description
      this.formValidate.downloadUrl = editData.downloadUrl
      this.formValidate.md5 = editData.md5
      this.formValidate.unzipPath = editData.unzipPath || '/home/sinano/images/triton_server/models_10.3'
      this.formValidate.dockerName = editData.dockerName || 'tritonserver-gpu'
      this.formValidate.versionType = editData.versionType || 'aiqc'
      if (editData.downloadUrl != null) {
        var video_path_array = editData.downloadUrl.split("/")
        this.show_path = video_path_array[video_path_array.length - 1]
      }
    },
    handleReset(name) {
      this.$refs[name].resetFields()
    }

  }
}
</script>
